import { DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { Button, HeadingRow, Icon } from '@vestigas/ui';

type P = {
  readonly onMinimize: () => void;
  readonly onSilentClose: () => void;
};

export function BugReportDialogHeader({ onMinimize, onSilentClose }: P) {
  const { t } = useTranslation('bugReport');

  return (
    <DialogTitle id="bug-report-dialog-title" className="px-4">
      <HeadingRow
        heading={t(($) => $.dialog.title)}
        action={
          <div className="flex shrink-0 items-center gap-2">
            <Button
              buttonStyle="link"
              onClick={onMinimize}
              text={t(($) => $.dialog.minimizeButton.label)}
            />
            <Button
              aria-label={t(($) => $.dialog.cancelButton.text)}
              size="small"
              onClick={onSilentClose}
              icon={<Icon metaphor="close" />}
            />
          </div>
        }
      />
    </DialogTitle>
  );
}
